import { IInitResponse } from '@/modules'
import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class GetInitResponseState extends BaseState {
    public begin() {
        GameSignals.initResponse.connect(this.end)
        GameSignals.getInitResponse.emit()
    }

    public end = (data: IInitResponse) => {
        this._model.initData = data
        this._stateMachine.setState(GameStatesEnum.LOADING_STATE)
    }

    public cleanUp() {
        GameSignals.initResponse.disconnect(this.end)
    }
}
